import { action, observable, makeObservable } from 'mobx';

export interface IActivity {
    action: string;
    body: any;
    createdOn: Date | string | null;
    id: string;
    item: string;
    params: any;
    query: any;
    relatedId: string | null;
    userId: string | null;
    remoteIp: string | null;
}

export default class UserActivityStore {
    activity: IActivity = {
        action: '',
        body: {},
        createdOn: null,
        id: '',
        item: '',
        params: {},
        query: {},
        relatedId: null,
        userId: '',
        remoteIp: null
    };

    constructor(activity: IActivity) {
        makeObservable(this, {
            activity: observable,
            update: action
        });

        this.update(activity);
    }

    update(activity: IActivity): void {
        this.activity = {
            ...this.activity,
            ...activity
        };
    }
}
